<template>
<div id="dashboard">
  <div id="dashboard-header">
    <v-btn flat dark :to="`/bot/${activeBot.code}`" class="report-back-btn text-capitalize">
      <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
      back
    </v-btn>
    <span id="dashboard-header-title">{{$t('dashboard')|capitalize}}</span>
    <div id="dashboard-header-bot-list">
      <span id="dashboard-header-active-bot">{{ activeBot ? activeBot.name : '' }}</span>
    </div>
  </div>
  <v-container fluid style="padding: 10px; background-color: #E5E5E5">
    <v-layout row wrap fill-height>
      <v-flex d-flex xs12 md6>
        <v-layout row wrap>
          <v-flex d-flex xs12>
            <CustomerDashboard/>
          </v-flex>
          <v-flex d-flex xs12>
            <TicketDashboard/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12 md6>
        <AgentDashboard/>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import {mapState} from "vuex";
import StaffService from "@/services/staff.service";
import _ from "lodash";
import CustomerDashboard from "@/views/dashboard/CustomerDashboard";
import TicketDashboard from "@/views/dashboard/TicketDashboard";
import AgentDashboard from "@/views/dashboard/AgentDashboard";

export default {
  name: "Dashboard",
  components: {AgentDashboard, TicketDashboard, CustomerDashboard},
  mounted() {
    this.initBotStaffList();
  },
  computed: {
    ...mapState(['botStaffList', 'user']),
    hasAdminRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9])
    },
    hasManageRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5])
    },
    activeBot() {
      const botCode = this.$route.params.bot_code;
      if (botCode) {
        let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
        return bot ? {code: bot.bot_code, name: bot.bot_name} : {}
      }
      return {}
    },
    botList() {
      return _.map(this.botStaffList, o => {
        return {name: o.bot_name, code: o.bot_code}
      });
    }
  },
  methods: {
    initBotStaffList() {
      if(this.botStaffList.length < 1) {
        this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "components/style/dashboard";
</style>